import React from "react";
import { Chip, Tooltip } from "@mui/material";
import useStyles from "../style/js-style/components/EAChipWithBackgroundStyle"

const EAChipWithBackground = ({ label, color, tooltip = "" }) => {
    const { classes } = useStyles();
    return (
        <Tooltip title={tooltip}>
            <Chip
                className={classes.root}
                style={{ backgroundColor: color, color: "white" }}
                label={label}
                size="small"
                color="default"
            />
        </Tooltip>
    )
}
export default EAChipWithBackground;
